// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.articleForm_form_wrap__isvl9 {
  padding: 20px 100px;
  text-align: center;
}
.articleForm_form_wrap__isvl9 .articleForm_input_wrap__ft1aU {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  text-align: left;
}
.articleForm_form_wrap__isvl9 .articleForm_input_wrap__ft1aU label {
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
}
.articleForm_form_wrap__isvl9 .articleForm_input_wrap__ft1aU input {
  height: 40px;
  font-weight: 400;
  font-size: 16px;
  border: none;
  padding: 0 15px;
  outline: none;
}
.articleForm_form_wrap__isvl9 .articleForm_input_wrap__ft1aU input::placeholder {
  font-weight: 400;
  font-size: 14px;
}
.articleForm_form_wrap__isvl9 .articleForm_input_wrap__ft1aU textarea {
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  width: 100%;
  height: 100%;
  min-height: 120px;
  padding: 13px 15px;
  border: none;
  outline: none;
}
.articleForm_form_wrap__isvl9 .articleForm_input_wrap__ft1aU textarea::placeholder {
  font-weight: 400;
  font-size: 14px;
}
.articleForm_form_wrap__isvl9 .articleForm_form_input_error__\\+z4ib span {
  color: red;
  font-size: 12px;
  line-height: 1;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C {
  display: flex;
  justify-content: space-between;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 {
  display: flex;
  align-items: center;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_preview__JMHo1 {
  width: 100px;
  margin-left: 20px;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_preview__JMHo1 img {
  width: 100%;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_input_file_wrap__TYjLE {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  text-align: left;
  width: 350px;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_input_file_wrap__TYjLE label {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_input_file_wrap__TYjLE input[type=file] {
  position: relative;
  width: 100%;
  height: 50px;
  max-width: 500px;
  padding: 13px 15px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  background-color: #ffffff;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_input_file_wrap__TYjLE input[type=file]::file-selector-button {
  position: absolute;
  right: -5px;
  top: 0px;
  border: none;
  background: #b0b3ba;
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  min-width: 170px;
  padding: 15px 0px;
  height: 100%;
  text-transform: uppercase;
  color: #000000;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_input_file_wrap__TYjLE input[type=file]::file-selector-button:hover {
  background: var(--gray-text-color);
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_select_wrap__YwVBK {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  margin-left: 10px;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_select_wrap__YwVBK label {
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 5px;
  text-align: left;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_select_wrap__YwVBK select {
  height: 50px;
  width: 100%;
  padding: 13px 18px;
  padding-right: 25px;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
}
.articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_select_wrap__YwVBK .error {
  color: red;
  font-size: 14px;
  line-height: 1;
  margin-bottom: 10px;
}
.articleForm_form_wrap__isvl9 .articleForm_select_services__DyrEL {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.articleForm_form_wrap__isvl9 .articleForm_select_services__DyrEL label {
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 5px;
  text-align: left;
}
.articleForm_form_wrap__isvl9 .articleForm_select_services__DyrEL select {
  height: 50px;
  width: 100%;
  padding: 13px 18px;
  padding-right: 25px;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
}
.articleForm_form_wrap__isvl9 .articleForm_select_services__DyrEL .error {
  color: red;
  font-size: 14px;
  line-height: 1;
  margin-bottom: 10px;
}
.articleForm_form_wrap__isvl9 .articleForm_checkbox_wrap__My12J {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.articleForm_form_wrap__isvl9 .articleForm_checkbox_wrap__My12J label {
  font-weight: 700;
  font-size: 16px;
  margin-left: 10px;
  text-transform: uppercase;
  padding: 0;
}
.articleForm_form_wrap__isvl9 .articleForm_checkbox_wrap__My12J input[type=checkbox] {
  width: 20px;
  height: 20px;
  border: 1px solid var(--border-default-color);
  border-radius: 3px;
  margin-left: 10px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.articleForm_form_wrap__isvl9 .articleForm_form_button__gHv9L {
  margin: 20px auto 0;
}
@media (max-width: 991px) {
  .articleForm_form_wrap__isvl9 {
    padding: 10px 30px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_input_wrap__ft1aU {
    margin-bottom: 10px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_input_wrap__ft1aU label {
    font-size: 14px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_input_wrap__ft1aU input {
    height: 30px;
    font-size: 14px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_input_wrap__ft1aU textarea {
    font-size: 14px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_preview__JMHo1 {
    width: 80px;
    margin-left: 10px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_input_file_wrap__TYjLE {
    width: 250px;
    margin-bottom: 10px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_input_file_wrap__TYjLE label {
    font-size: 14px;
    margin-bottom: 5px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_input_file_wrap__TYjLE input[type=file] {
    height: 40px;
    padding: 10px 15px;
    font-size: 14px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_input_preview_wrap__tiIg2 .articleForm_input_file_wrap__TYjLE input[type=file]::file-selector-button {
    font-size: 11px;
    min-width: 120px;
    padding: 10px 0px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_select_wrap__YwVBK {
    margin-bottom: 10px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_select_wrap__YwVBK label {
    font-size: 14px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_article_images_wrap__BjQ7C .articleForm_select_wrap__YwVBK select {
    height: 40px;
    padding: 10px 15px;
    font-size: 14px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_select_services__DyrEL {
    margin-bottom: 10px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_select_services__DyrEL label {
    font-size: 14px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_select_services__DyrEL select {
    height: 40px;
    padding: 10px 15px;
    font-size: 14px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_checkbox_wrap__My12J label {
    font-size: 14px;
  }
  .articleForm_form_wrap__isvl9 .articleForm_checkbox_wrap__My12J input[type=checkbox] {
    width: 15px;
    height: 15px;
    margin-left: 5px;
  }
}
@media (max-width: 800px) {
  .articleForm_form_wrap__isvl9 {
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Forms/ArticleForm/articleForm.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AACN;AAEI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAAN;AAEM;EACE,gBAAA;EACA,eAAA;AAAR;AAII;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAFN;AAIM;EACE,gBAAA;EACA,eAAA;AAFR;AAQI;EACE,UAAA;EACA,eAAA;EACA,cAAA;AANN;AAUE;EACE,aAAA;EACA,8BAAA;AARJ;AAUI;EACE,aAAA;EACA,mBAAA;AARN;AAUM;EACE,YAAA;EACA,iBAAA;AARR;AAUQ;EACE,WAAA;AARV;AAYM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAVR;AAYQ;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AAVV;AAaQ;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gCAAA;AAXV;AAcQ;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;AAZV;AAeQ;EACE,kCAAA;AAbV;AAkBI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAhBN;AAkBM;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAhBR;AAkBM;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAhBR;AAmBM;EACE,UAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAjBR;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AApBJ;AAsBI;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AApBN;AAsBI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AApBN;AAuBI;EACE,UAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AArBN;AAyBE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAvBJ;AAyBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;AAvBN;AA0BI;EACE,WAAA;EACA,YAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;AAxBN;AA4BE;EACE,mBAAA;AA1BJ;AA6BE;EA7NF;IA8NI,kBAAA;EA1BF;EA4BE;IACE,mBAAA;EA1BJ;EA4BI;IACE,eAAA;EA1BN;EA6BI;IACE,YAAA;IACA,eAAA;EA3BN;EA8BI;IACE,eAAA;EA5BN;EAiCM;IACE,WAAA;IACA,iBAAA;EA/BR;EAkCM;IACE,YAAA;IACA,mBAAA;EAhCR;EAkCQ;IACE,eAAA;IACA,kBAAA;EAhCV;EAmCQ;IACE,YAAA;IACA,kBAAA;IACA,eAAA;EAjCV;EAoCQ;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EAlCV;EAsCI;IACE,mBAAA;EApCN;EAsCM;IACE,eAAA;EApCR;EAuCM;IACE,YAAA;IACA,kBAAA;IACA,eAAA;EArCR;EAyCE;IACE,mBAAA;EAvCJ;EAyCI;IACE,eAAA;EAvCN;EA0CI;IACE,YAAA;IACA,kBAAA;IACA,eAAA;EAxCN;EA6CI;IACE,eAAA;EA3CN;EA8CI;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EA5CN;AACF;AAgDE;EAtTF;IAuTI,aAAA;EA7CF;AACF","sourcesContent":[".form_wrap {\n  padding: 20px 100px;\n  text-align: center;\n\n  .input_wrap {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n    text-align: left;\n\n    label {\n      margin-bottom: 5px;\n      font-weight: 700;\n      font-size: 16px;\n      text-transform: uppercase;\n    }\n\n    input {\n      height: 40px;\n      font-weight: 400;\n      font-size: 16px;\n      border: none;\n      padding: 0 15px;\n      outline: none;\n\n      &::placeholder {\n        font-weight: 400;\n        font-size: 14px;\n      }\n    }\n\n    textarea {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 1;\n      width: 100%;\n      height: 100%;\n      min-height: 120px;\n      padding: 13px 15px;\n      border: none;\n      outline: none;\n\n      &::placeholder {\n        font-weight: 400;\n        font-size: 14px;\n      }\n    }\n  }\n\n  .form_input_error {\n    span {\n      color: red;\n      font-size: 12px;\n      line-height: 1;\n    }\n  }\n\n  .article_images_wrap {\n    display: flex;\n    justify-content: space-between;\n\n    .input_preview_wrap {\n      display: flex;\n      align-items: center;\n\n      .preview {\n        width: 100px;\n        margin-left: 20px;\n\n        img {\n          width: 100%;\n        }\n      }\n\n      .input_file_wrap {\n        display: flex;\n        flex-direction: column;\n        margin-bottom: 20px;\n        text-align: left;\n        width: 350px;\n\n        label {\n          font-weight: 700;\n          font-size: 16px;\n          margin-bottom: 10px;\n          text-transform: uppercase;\n        }\n\n        input[type=\"file\"] {\n          position: relative;\n          width: 100%;\n          height: 50px;\n          max-width: 500px;\n          padding: 13px 15px;\n          font-weight: 400;\n          font-size: 14px;\n          line-height: 24px;\n          background-color: #ffffff;\n          border-top-right-radius: 12px;\n          border-bottom-right-radius: 12px;\n        }\n\n        input[type=\"file\"]::file-selector-button {\n          position: absolute;\n          right: -5px;\n          top: 0px;\n          border: none;\n          background: #b0b3ba;\n          border-radius: 12px;\n          font-weight: 700;\n          font-size: 14px;\n          line-height: 16px;\n          min-width: 170px;\n          padding: 15px 0px;\n          height: 100%;\n          text-transform: uppercase;\n          color: #000000;\n          cursor: pointer;\n          transition: background 0.2s ease-in-out;\n        }\n\n        input[type=\"file\"]::file-selector-button:hover {\n          background: var(--gray-text-color);\n        }\n      }\n    }\n\n    .select_wrap {\n      display: flex;\n      flex-direction: column;\n      margin-bottom: 20px;\n      margin-left: 10px;\n\n      label {\n        text-transform: uppercase;\n        font-size: 14px;\n        font-weight: 700;\n        margin-bottom: 5px;\n        text-align: left;\n      }\n      select {\n        height: 50px;\n        width: 100%;\n        padding: 13px 18px;\n        padding-right: 25px;\n        border: none;\n        outline: none;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 1;\n      }\n\n      :global(.error) {\n        color: red;\n        font-size: 14px;\n        line-height: 1;\n        margin-bottom: 10px;\n      }\n    }\n  }\n\n  .select_services {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n\n    label {\n      text-transform: uppercase;\n      font-size: 14px;\n      font-weight: 700;\n      margin-bottom: 5px;\n      text-align: left;\n    }\n    select {\n      height: 50px;\n      width: 100%;\n      padding: 13px 18px;\n      padding-right: 25px;\n      border: none;\n      outline: none;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 1;\n    }\n\n    :global(.error) {\n      color: red;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 10px;\n    }\n  }\n\n  .checkbox_wrap {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n\n    label {\n      font-weight: 700;\n      font-size: 16px;\n      margin-left: 10px;\n      text-transform: uppercase;\n      padding: 0;\n    }\n\n    input[type=\"checkbox\"] {\n      width: 20px;\n      height: 20px;\n      border: 1px solid var(--border-default-color);\n      border-radius: 3px;\n      margin-left: 10px;\n      cursor: pointer;\n      transition: all 0.2s ease-in-out;\n    }\n  }\n\n  .form_button {\n    margin: 20px auto 0;\n  }\n\n  @media (max-width: 991px) {\n    padding: 10px 30px;\n\n    .input_wrap {\n      margin-bottom: 10px;\n\n      label {\n        font-size: 14px;\n      }\n\n      input {\n        height: 30px;\n        font-size: 14px;\n      }\n\n      textarea {\n        font-size: 14px;\n      }\n    }\n    .article_images_wrap {\n      .input_preview_wrap {\n        .preview {\n          width: 80px;\n          margin-left: 10px;\n        }\n\n        .input_file_wrap {\n          width: 250px;\n          margin-bottom: 10px;\n\n          label {\n            font-size: 14px;\n            margin-bottom: 5px;\n          }\n\n          input[type=\"file\"] {\n            height: 40px;\n            padding: 10px 15px;\n            font-size: 14px;\n          }\n\n          input[type=\"file\"]::file-selector-button {\n            font-size: 11px;\n            min-width: 120px;\n            padding: 10px 0px;\n          }\n        }\n      }\n      .select_wrap {\n        margin-bottom: 10px;\n\n        label {\n          font-size: 14px;\n        }\n\n        select {\n          height: 40px;\n          padding: 10px 15px;\n          font-size: 14px;\n        }\n      }\n    }\n    .select_services {\n      margin-bottom: 10px;\n\n      label {\n        font-size: 14px;\n      }\n\n      select {\n        height: 40px;\n        padding: 10px 15px;\n        font-size: 14px;\n      }\n    }\n\n    .checkbox_wrap {\n      label {\n        font-size: 14px;\n      }\n\n      input[type=\"checkbox\"] {\n        width: 15px;\n        height: 15px;\n        margin-left: 5px;\n      }\n    }\n  }\n\n  @media (max-width: 800px) {\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form_wrap": `articleForm_form_wrap__isvl9`,
	"input_wrap": `articleForm_input_wrap__ft1aU`,
	"form_input_error": `articleForm_form_input_error__+z4ib`,
	"article_images_wrap": `articleForm_article_images_wrap__BjQ7C`,
	"input_preview_wrap": `articleForm_input_preview_wrap__tiIg2`,
	"preview": `articleForm_preview__JMHo1`,
	"input_file_wrap": `articleForm_input_file_wrap__TYjLE`,
	"select_wrap": `articleForm_select_wrap__YwVBK`,
	"select_services": `articleForm_select_services__DyrEL`,
	"checkbox_wrap": `articleForm_checkbox_wrap__My12J`,
	"form_button": `articleForm_form_button__gHv9L`
};
export default ___CSS_LOADER_EXPORT___;
